import { render, staticRenderFns } from "./YesNoBadge.vue?vue&type=template&id=9d5082b8&"
import script from "./YesNoBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./YesNoBadge.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports